import React from 'react';
import Banner from './section-components/banner';
import Trending from './section-components/trending';
import EditorsPicks from './section-components/editors-picks';
import CatSection from './section-components/cat-section';
import Video from './section-components/video';
import Add from './section-components/add';
import TrendingV2 from './section-components/trending-v2';

const Home_V1 = () => {
    return <div>
        <Banner />
        <Trending />
        <EditorsPicks />
        <CatSection />
        <Video />
        <Add />
        <TrendingV2 />
    </div>
}

export default Home_V1

